import TaskList from './components/TaskList/TaskList';

function App() {
  return (
    <div className="App">
     <TaskList></TaskList>
    </div>
  );
}

export default App;
